import { ButtonUI, DialogUI, FormLabelUI, InputUI } from '../Interface';

export const Dialog = ({ open, handleClose, jokerFieldState, handleSaveJokerField }) => {
  const { jokerFieldVal, setJokerFieldVal } = jokerFieldState;
  return (
    <DialogUI
      open={open}
      onClose={handleClose}
      headerContent="Információ"
      sx={{
        '& .MuiDialog-container': {
          '& .MuiPaper-root': {
            width: '100%',
            maxWidth: '500px',
          },
        },
      }}
    >
      <div className="text-labelColor mt-2">
        <InputUI
          variant="standard"
          label={<FormLabelUI text="Megnevezés" />}
          onChange={(e) => {
            setJokerFieldVal((prev) => ({
              ...prev,
              joker_char1: e.target.value,
            }));
          }}
          value={jokerFieldVal.joker_char1}
        />
      </div>
      <div className="flex justify-center mt-5 gap-2">
        <ButtonUI text="Mentés" className="bg-success" onClick={handleSaveJokerField} />
        <ButtonUI text="Bezárás" color="blue-gray" variant="gradient" onClick={handleClose} />
      </div>
    </DialogUI>
  );
};
